import React from 'react';

interface DetailFieldProps {
  label: string;
  value: string;
}

export const DetailField: React.FC<DetailFieldProps> = ({ label, value }) => (
  <div className="space-y-1">
    <p className="text-xs font-medium uppercase tracking-wide text-gray-500">{label}</p>
    <p className="break-words text-sm text-gray-900">{value}</p>
  </div>
);
